import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-summary-list" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_summary_list_item = _resolveComponent("summary-list-item")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "header"),
    _createElementVNode("div", {
      class: _normalizeClass($options.summaryListClasses)
    }, [
      _renderSlot(_ctx.$slots, "description"),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.summaryListData, (summaryListItem, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (summaryListItem.isDivider)
            ? (_openBlock(), _createElementBlock("div", {
                key: `${summaryListItem.title}-${index}`,
                class: "gfu-summary-list-wrapper__divider"
              }))
            : (_openBlock(), _createBlock(_component_summary_list_item, _mergeProps({
                key: 1,
                ref_for: true
              }, summaryListItem, {
                key: `${summaryListItem.title}-${index}`
              }), null, 16 /* FULL_PROPS */))
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */)),
      _renderSlot(_ctx.$slots, "actions")
    ], 2 /* CLASS */)
  ]))
}